import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { subscribeToAdminAuth } from "../../utils/auth";

export default function ProtectedRoute({
  children,
  allowedRoles = ["admin", "teacher", "viewer"],
}) {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("ac_admin_user");

    if (stored) {
      setUser(JSON.parse(stored));
      setLoading(false);
      return;
    }

    const unsubscribe = subscribeToAdminAuth((nextUser) => {
      setUser(nextUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          fontSize: "1rem",
        }}
      >
        AceTime lädt...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}